__turbopack_context__.v({
  "ask": "Dock-module__gzT0la__ask",
  "btn": "Dock-module__gzT0la__btn",
  "chip": "Dock-module__gzT0la__chip",
  "counter": "Dock-module__gzT0la__counter",
  "dock": "Dock-module__gzT0la__dock",
  "dockIn": "Dock-module__gzT0la__dockIn",
  "dot": "Dock-module__gzT0la__dot",
  "dots": "Dock-module__gzT0la__dots",
  "handle": "Dock-module__gzT0la__handle",
  "idx": "Dock-module__gzT0la__idx",
  "lensBtn": "Dock-module__gzT0la__lensBtn",
  "lensWrap": "Dock-module__gzT0la__lensWrap",
  "nav": "Dock-module__gzT0la__nav",
  "pip": "Dock-module__gzT0la__pip",
  "play": "Dock-module__gzT0la__play",
  "pop": "Dock-module__gzT0la__pop",
  "popIn": "Dock-module__gzT0la__popIn",
  "popItem": "Dock-module__gzT0la__popItem",
  "ring": "Dock-module__gzT0la__ring",
  "seg": "Dock-module__gzT0la__seg",
  "sep": "Dock-module__gzT0la__sep",
  "thumb": "Dock-module__gzT0la__thumb",
  "tip": "Dock-module__gzT0la__tip",
});
